import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import Item from 'components/ServiciosHogarPlanes/Item';

function Table({hogarPlanes = [], getHogarPlanes, deleteHogarPlan, totalPages, setPage, page, isSearched, setIsSearched, formEstado, category}){
 let myAbilities = HelpAbility();
 const {search, option, state} = isSearched;

 const handlePageClick = (data) => {
  state ? getHogarPlanes({page: data.selected + 1, [option]: search, category}) : getHogarPlanes({page: data.selected + 1, category})  ;
 };

 const resetHogarPlanes = async () => {
    setIsSearched({
       search: '',
       option: '',
       state: false
    })
    setPage(1);
    getHogarPlanes({});
 };
 return (
  <div className="mt-4">
   <div className="row mb-2">
    <div className="col d-flex align-items-end">
     <h6>Planes registrados</h6>
    </div>
    <div className="col d-flex justify-content-end"> 
     <div className="col-auto">
      <button type="submit" className="btn btn-primary" onClick={resetHogarPlanes}>Cargar todos</button>
     </div>
    </div>
   </div>
   <div className="table-responsive     rounded-3" style={{border: '1px solid black'}}>
    <table className="table">
     <thead>
      <tr>
          <th scope="col" className="text-center">#</th>
          {formEstado.image && 
           <th scope="col" className="text-center">Imagen</th>
          }         
          {formEstado.subcategory &&
           <th scope="col" className="text-center">Subcategoría</th>
          }
          <th scope="col" className="text-center">Plan</th>
          {formEstado.benefits &&
           <th scope="col" className="text-center">Beneficios</th>
          }
          <th scope="col" className="text-center">Precio Unitario</th>
          {formEstado.comboPrice && 
           <th scope="col" className="text-center">Precio Combo</th>
          }
          <th scope="col" className="text-center">Estado</th>
          {myAbilities.hasAny([C.A.DEPARTAMENT.UPDATE, C.A.DEPARTAMENT.DELETE]) && 
          <th scope="col" className="text-center">Acción</th>}
      </tr>
     </thead>
     <tbody>
     {
        hogarPlanes.length ? 
        hogarPlanes.map((hogarPlan, i) => <Item 
            key={hogarPlan._id}  
            i={i} 
            hogarPlan={hogarPlan} 
            deleteHogarPlan={deleteHogarPlan}
            formEstado={formEstado}
            category={category}
        />) 
        :
        <tr>
            <td colSpan="5">Sin datos</td>
        </tr>
     }
     </tbody>
    </table>
   </div>
   <div>
       <ReactPaginate
           previousLabel={"Anterior"}
           nextLabel={"Siguiente"}
           breakLabel={"..."}
           pageCount={totalPages}
           //Cuantas paginas quieres mostrar despues de los 3 ...
           marginPagesDisplayed={1}
           //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
           pageRangeDisplayed={2}
           forcePage={page - 1}
           onPageChange={handlePageClick}
           containerClassName={"pagination justify-content-center mt-3"}
           pageClassName={"page-item"}
           pageLinkClassName={"page-link"}
           previousClassName={"page-item"}
           previousLinkClassName={"page-link"}
           nextClassName={"page-item"}
           nextLinkClassName={"page-link"}
           breakClassName={"page-item"}
           breakLinkClassName={"page-link"}
           activeClassName={"active"}
       />
   </div>
 </div>
 )
}

export default Table
